import moment from 'moment'

export const data = () => ({
  isDebug: true,
  loading: false,
  statusFilter: 'pending',
  toggle: false,
  selectedBallot: null,
  selectedBallotID: 0,
  formatDateFn: function(value) {
    return value != null ? moment(value, 'YYYY/MM/DD HH:mm:ss').format('MM-DD-YYYY') : ''
  },

  filters: {
    show: false
  },

  region: {},

  rows: [],

  columns: [
    {
      field: 'description',
      label: 'Description',
      aria: 'Description',
      width: '40%',
      sortable: true,
      searchable: true
    },
    {
      field: 'ballotType',
      label: 'Type',
      aria: 'Type',
      width: '20%',
      sortable: true,
      searchable: true
    },
    {
      field: 'submittedBallots',
      label: 'Submitted Ballots',
      aria: 'Submitted Ballots',
      width: '10%',
      sortable: true,
      searchable: true
    },
    {
      field: 'completeByDate',
      label: 'Complete By',
      aria: 'Complete By',
      width: '10%',
      date: true,
      sortable: true,
      searchable: true
    },
    {
      field: 'publishedDate',
      label: 'Published',
      aria: 'Published',
      width: '10%',
      date: true,
      sortable: true,
      searchable: true
    }
  ],

  styles: {
    formRow: {
      padding: '10px',
      whiteSpace: 'nowrap'
    },
    filterButton: {
      float: 'right',
      marginTop: '4px'
    }
  }
})
